import React, { useState } from "react";
import "./DashboardLayout.css";

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="dashboard-root">
      {/* SIDEBAR */}
      <aside
        className={`dashboard-sidebar ${
          isSidebarOpen ? "dashboard-sidebar--open" : ""
        }`}
      >
        <div className="sidebar-header">
          <div className="sidebar-logo-circle" />
          <span className="sidebar-logo-text">WELTOC</span>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">HOME</div>
          <button className="sidebar-link sidebar-link--active">
            <span className="sidebar-link-dot" />
            Nos Produits
          </button>

          <div className="sidebar-section-label">Menu de navigation</div>
          <button className="sidebar-link">Tableau de bord</button>
          <button className="sidebar-link">Mes Commandes</button>
          <button className="sidebar-link">Mon Profil</button>

          <div className="sidebar-section-label">Support Technique</div>
          <button className="sidebar-link">Nous Contacter</button>
          <button className="sidebar-link">Foires Aux Questions</button>
          <button className="sidebar-link">Comment ça marche? </button>
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user-card">
            <div className="sidebar-user-avatar">J</div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">Jane Cooper</div>
              <div className="sidebar-user-role">Admin</div>
            </div>
          </div>
          <div className="sidebar-footer-links">
            <button className="sidebar-footer-btn">Se Deconnecter</button>
          </div>
        </div>
      </aside>

      {/* OVERLAY mobile quand sidebar ouverte */}
      {isSidebarOpen && (
        <div className="dashboard-overlay" onClick={closeSidebar} />
      )}

      {/* CONTENU DROITE */}
      <div className="dashboard-main">
        {/* NAVBAR */}
        <header className="dashboard-navbar">
          <div className="navbar-left">
            {/* Bouton burger visible sur mobile */}
            <button
              className="navbar-burger"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <span />
              <span />
              <span />
            </button>

            <h1 className="navbar-title">Dashboard</h1>
          </div>

          <div className="navbar-center">
            
          </div>

          <div className="navbar-right">
            <button className="navbar-icon-btn">🔔</button>
            <button className="navbar-icon-btn">⚙️</button>
            <div className="navbar-user-mini">J</div>
          </div>
        </header>

        {/* ZONE CENTRALE POUR TES COMPOSANTS */}
        <main className="dashboard-content">{children}</main>
      </div>
    </div>
  );
};

export default DashboardLayout;
